export default "__VITE_ASSET__CbtQNShC__"